module.exports = __webpack_public_path__ + "static/media/turtle.7e70f68d.png";